// extracted by mini-css-extract-plugin
export var cardLayout = "_1z-1";
export var paginationContainer = "_1z-0";